import { render, staticRenderFns } from "./TabelaDownload.vue?vue&type=template&id=f53bc866&scoped=true"
import script from "./TabelaDownload.vue?vue&type=script&lang=js"
export * from "./TabelaDownload.vue?vue&type=script&lang=js"
import style0 from "./TabelaDownload.vue?vue&type=style&index=0&id=f53bc866&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f53bc866",
  null
  
)

export default component.exports